(function () {
  "use strict";

  var STORAGE_VOTER = "ohcv-voter-v1";
  var STORAGE_VOTES = "ohcv-votes-v2";
  var STORAGE_DEMO_SCORES = "ohcv-demo-scores-v2";

  function readStorage(key, fallback) {
    try {
      var value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Voting still works for this page view when storage is unavailable.
    }
  }

  function getVoterId() {
    try {
      var saved = window.localStorage.getItem(STORAGE_VOTER);
      if (saved) return saved;

      var id = window.crypto && typeof window.crypto.randomUUID === "function"
        ? window.crypto.randomUUID()
        : createFallbackVoterId();
      window.localStorage.setItem(STORAGE_VOTER, id);
      return id;
    } catch (error) {
      return createFallbackVoterId();
    }
  }

  function createFallbackVoterId() {
    var values = new Uint32Array(4);
    if (window.crypto && typeof window.crypto.getRandomValues === "function") {
      window.crypto.getRandomValues(values);
    } else {
      values[0] = Date.now();
      values[1] = window.performance && window.performance.now
        ? Math.floor(window.performance.now() * 1000)
        : 0;
      values[2] = values[0] ^ 0xa5a5a5a5;
      values[3] = values[1] ^ 0x5a5a5a5a;
    }
    return "ohcv-" + Array.prototype.map.call(values, function (value) {
      return value.toString(36);
    }).join("-");
  }

  function formatNumber(value) {
    try {
      return new Intl.NumberFormat().format(value);
    } catch (error) {
      return String(value);
    }
  }

  function cleanEndpoint(value) {
    return String(value || "").trim().replace(/\/+$/, "");
  }

  function FruitVote(root) {
    this.root = root;
    this.cardsContainer = root.querySelector("[data-ohcv-cards]");
    this.status = root.querySelector("[data-ohcv-status]");
    this.updated = root.querySelector("[data-ohcv-updated]");
    this.totalVotesElement = root.querySelector("[data-ohcv-total-votes]");
    this.progressLabel = root.querySelector("[data-ohcv-progress-label]");
    this.progressBar = root.querySelector("[data-ohcv-progress-bar]");
    this.finishButton = root.querySelector("[data-ohcv-finish]");
    this.finishLabel = root.querySelector("[data-ohcv-finish-label]");
    this.finishHint = root.querySelector("[data-ohcv-finish-hint]");
    this.dialog = root.querySelector("[data-ohcv-dialog]");
    this.signatureSlots = Array.prototype.slice.call(root.querySelectorAll("[data-ohcv-signature-slots] > li"));
    this.dialogTopFive = root.querySelector("[data-ohcv-dialog-top-five]");
    this.endpoint = cleanEndpoint(root.dataset.apiUrl);
    this.minimumVotes = Math.max(1, Number(root.dataset.minimumVotes) || 5);
    this.pollMilliseconds = Math.max(5000, (Number(root.dataset.pollSeconds) || 15) * 1000);
    this.finishLockedLabel = root.dataset.finishLocked || "Finish My Ballot";
    this.finishUnlockedLabel = root.dataset.finishUnlocked || "See My Impact";
    this.votedSuffix = root.dataset.votedSuffix || "fruits voted";
    this.voterId = getVoterId();
    this.localVotes = readStorage(STORAGE_VOTES, {});
    this.demoScores = readStorage(STORAGE_DEMO_SCORES, {});
    this.totalVotes = null;
    this.pollTimer = 0;
    this.destroyed = false;
    this.fruits = [];
    this.fruitById = {};

    this.collectFruitData();
    this.bindEvents();
    this.applySavedVotes();
    this.sortAndRender(false);
    this.updateProgress();

    if (this.endpoint) {
      this.loadRankings();
      this.startPolling();
    } else {
      this.updated.textContent = "Preview mode";
      this.totalVotesElement.textContent = "Local demo";
    }

    if (this.dialog && this.dialog.querySelector("[data-ohcv-email-success]")) {
      this.openDialog();
    }
  }

  FruitVote.prototype.collectFruitData = function () {
    var self = this;
    var cards = Array.prototype.slice.call(this.root.querySelectorAll("[data-ohcv-card]"));

    cards.forEach(function (card, index) {
      var id = card.dataset.fruitId;
      if (!id || self.fruitById[id]) return;

      var seedScore = Number(card.dataset.seedScore) || 0;
      var storedDemo = self.demoScores[id];
      var score = !self.endpoint && storedDemo && typeof storedDemo.score === "number"
        ? storedDemo.score
        : seedScore;
      var likes = !self.endpoint && storedDemo && typeof storedDemo.likes === "number"
        ? storedDemo.likes
        : Math.max(score, 0);
      var dislikes = !self.endpoint && storedDemo && typeof storedDemo.dislikes === "number"
        ? storedDemo.dislikes
        : Math.max(-score, 0);

      var fruit = {
        id: id,
        name: card.dataset.fruitName || id,
        originalIndex: Number(card.dataset.originalIndex) || index,
        membership: card.dataset.membership || "none",
        card: card,
        image: card.querySelector(".ohc-vote-card__art img"),
        score: score,
        likes: likes,
        dislikes: dislikes,
      };

      self.fruits.push(fruit);
      self.fruitById[id] = fruit;
      self.renderFruit(fruit);
    });
  };

  FruitVote.prototype.bindEvents = function () {
    var self = this;

    this.root.addEventListener("click", function (event) {
      var voteButton = event.target.closest("[data-ohcv-vote]");
      if (voteButton && self.root.contains(voteButton)) {
        var card = voteButton.closest("[data-ohcv-card]");
        if (card) self.vote(card.dataset.fruitId, Number(voteButton.dataset.ohcvVote), voteButton);
        return;
      }

    });

    if (this.finishButton) {
      this.finishButton.addEventListener("click", function () {
        if (!self.finishButton.disabled) self.openDialog();
      });
    }

    var closeButton = this.root.querySelector("[data-ohcv-dialog-close]");
    if (closeButton) closeButton.addEventListener("click", function () { self.closeDialog(); });

    var keepVoting = this.root.querySelector("[data-ohcv-keep-voting]");
    if (keepVoting) keepVoting.addEventListener("click", function () { self.closeDialog(); });

    var share = this.root.querySelector("[data-ohcv-share]");
    if (share) share.addEventListener("click", function () { self.share(share); });

    this.onVisibilityChange = function () {
      if (!self.endpoint || self.destroyed) return;
      if (document.hidden) {
        window.clearInterval(self.pollTimer);
        self.pollTimer = 0;
      } else {
        self.loadRankings();
        self.startPolling();
      }
    };
    document.addEventListener("visibilitychange", this.onVisibilityChange);
  };

  FruitVote.prototype.applySavedVotes = function () {
    var self = this;
    this.fruits.forEach(function (fruit) {
      var value = Number(self.localVotes[fruit.id]);
      if (value !== 1 && value !== -1) return;
      self.setPressedState(fruit, value);
    });
  };

  FruitVote.prototype.setPressedState = function (fruit, value) {
    var buttons = fruit.card.querySelectorAll("[data-ohcv-vote]");
    buttons.forEach(function (button) {
      button.setAttribute("aria-pressed", Number(button.dataset.ohcvVote) === value ? "true" : "false");
    });
    fruit.card.classList.toggle("is-voted", value === 1 || value === -1);
  };

  FruitVote.prototype.renderFruit = function (fruit) {
    var score = fruit.card.querySelector("[data-ohcv-score]");
    if (score) score.textContent = formatNumber(fruit.score);
  };

  FruitVote.prototype.vote = function (fruitId, value, sourceButton) {
    var self = this;
    var fruit = this.fruitById[fruitId];
    if (!fruit || (value !== 1 && value !== -1)) return;

    var previousValue = Number(this.localVotes[fruitId]);
    if (previousValue !== 1 && previousValue !== -1) previousValue = 0;
    var nextValue = previousValue === value ? 0 : value;

    var snapshot = {
      score: fruit.score,
      likes: fruit.likes,
      dislikes: fruit.dislikes,
      previousValue: previousValue,
      totalVotes: this.totalVotes,
    };

    if (previousValue === 1) fruit.likes = Math.max(0, fruit.likes - 1);
    if (previousValue === -1) fruit.dislikes = Math.max(0, fruit.dislikes - 1);
    if (nextValue === 1) fruit.likes += 1;
    if (nextValue === -1) fruit.dislikes += 1;
    fruit.score += nextValue - previousValue;
    if (nextValue === 0) {
      delete this.localVotes[fruitId];
    } else {
      this.localVotes[fruitId] = nextValue;
    }
    writeStorage(STORAGE_VOTES, this.localVotes);

    if (this.totalVotes !== null) {
      if (previousValue === 0 && nextValue !== 0) this.totalVotes += 1;
      if (previousValue !== 0 && nextValue === 0) this.totalVotes = Math.max(0, this.totalVotes - 1);
    }
    this.setPressedState(fruit, nextValue);
    this.renderFruit(fruit);
    this.updateTotalVotes();
    this.updateProgress();
    this.sortAndRender(true);
    this.popCard(fruit.card);
    if (nextValue === 0) {
      this.announce("Vote removed for " + fruit.name + ". New score " + fruit.score + ".");
    } else {
      this.announce((nextValue === 1 ? "Thumbs up for " : "Thumbs down for ") + fruit.name + ". New score " + fruit.score + ".");
    }

    if (!this.endpoint) {
      this.demoScores[fruitId] = {
        score: fruit.score,
        likes: fruit.likes,
        dislikes: fruit.dislikes,
      };
      writeStorage(STORAGE_DEMO_SCORES, this.demoScores);
      return;
    }

    fruit.card.classList.add("is-saving");
    fruit.card.querySelectorAll("[data-ohcv-vote]").forEach(function (button) {
      button.disabled = true;
    });

    fetch(this.endpoint + "/vote", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        fruitId: fruitId,
        value: nextValue,
        voterId: this.voterId,
      }),
      cache: "no-store",
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Vote request failed");
        return response.json();
      })
      .then(function (payload) {
        self.mergeRankings(payload);
        self.updated.textContent = "Live · just now";
      })
      .catch(function () {
        fruit.score = snapshot.score;
        fruit.likes = snapshot.likes;
        fruit.dislikes = snapshot.dislikes;
        self.totalVotes = snapshot.totalVotes;

        if (snapshot.previousValue === 0) {
          delete self.localVotes[fruitId];
          self.setPressedState(fruit, 0);
        } else {
          self.localVotes[fruitId] = snapshot.previousValue;
          self.setPressedState(fruit, snapshot.previousValue);
        }

        writeStorage(STORAGE_VOTES, self.localVotes);
        self.renderFruit(fruit);
        self.updateTotalVotes();
        self.updateProgress();
        self.sortAndRender(true);
        self.updated.textContent = "Could not save · retry";
        self.announce("Your vote could not be saved. Please try again.");
      })
      .then(function () {
        fruit.card.classList.remove("is-saving");
        fruit.card.querySelectorAll("[data-ohcv-vote]").forEach(function (button) {
          button.disabled = false;
        });
      });
  };

  FruitVote.prototype.popCard = function (card) {
    card.classList.remove("is-pop");
    void card.offsetWidth;
    card.classList.add("is-pop");
    window.setTimeout(function () { card.classList.remove("is-pop"); }, 550);
  };

  FruitVote.prototype.getSortedFruits = function () {
    return this.fruits.slice().sort(function (a, b) {
      return b.score - a.score || b.likes - a.likes || a.originalIndex - b.originalIndex;
    });
  };

  FruitVote.prototype.sortAndRender = function (animate) {
    var self = this;
    var sorted = this.getSortedFruits();
    var cardPositions = {};
    var canAnimate = animate && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (canAnimate) {
      this.fruits.forEach(function (fruit) {
        cardPositions[fruit.id] = fruit.card.getBoundingClientRect();
      });
    }

    sorted.forEach(function (fruit, index) {
      self.cardsContainer.appendChild(fruit.card);

      var rank = index + 1;
      var cardRank = fruit.card.querySelector("[data-ohcv-card-rank]");
      if (cardRank) {
        cardRank.textContent = "#" + rank;
        cardRank.setAttribute("aria-label", "Rank " + rank);
      }
      fruit.card.classList.toggle("is-top-five", rank <= 5);
    });

    if (canAnimate) {
      sorted.forEach(function (fruit) {
        var oldCard = cardPositions[fruit.id];
        var newCard = fruit.card.getBoundingClientRect();
        if (oldCard && (oldCard.left !== newCard.left || oldCard.top !== newCard.top)) {
          fruit.card.animate(
            [
              { transform: "translate(" + (oldCard.left - newCard.left) + "px, " + (oldCard.top - newCard.top) + "px)" },
              { transform: "translate(0, 0)" },
            ],
            { duration: 430, easing: "cubic-bezier(.2,.8,.2,1)" },
          );
        }
      });
    }

    this.updateTopFive(sorted.slice(0, 5));
  };

  FruitVote.prototype.updateTopFive = function (topFive) {
    var self = this;
    this.signatureSlots.forEach(function (slot, index) {
      var fruit = topFive[index];
      var art = slot.querySelector("[data-ohcv-slot-art]");
      var name = slot.querySelector("[data-ohcv-slot-name]");
      var score = slot.querySelector("[data-ohcv-slot-score]");
      if (!art || !name) return;

      art.replaceChildren();
      if (!fruit) {
        name.textContent = "Open seat";
        if (score) score.textContent = "—";
        return;
      }

      if (fruit.image) {
        var image = fruit.image.cloneNode(true);
        image.alt = "";
        image.removeAttribute("loading");
        image.removeAttribute("width");
        image.removeAttribute("height");
        art.appendChild(image);
      }
      name.textContent = fruit.name;
      if (score) score.textContent = formatNumber(fruit.score);
    });

    if (this.dialogTopFive) {
      this.dialogTopFive.replaceChildren();
      topFive.forEach(function (fruit, index) {
        var item = document.createElement("li");
        item.textContent = (index + 1) + ". " + fruit.name;
        self.dialogTopFive.appendChild(item);
      });
    }
  };

  FruitVote.prototype.updateProgress = function () {
    var self = this;
    var count = this.fruits.reduce(function (total, fruit) {
      var value = Number(self.localVotes[fruit.id]);
      return total + (value === 1 || value === -1 ? 1 : 0);
    }, 0);
    var total = this.fruits.length;
    var unlocked = count >= Math.min(this.minimumVotes, total);
    this.root.classList.toggle("has-started", count > 0);

    if (this.progressLabel) {
      this.progressLabel.textContent = count + " / " + total + " " + this.votedSuffix;
    }
    if (this.progressBar) this.progressBar.style.width = (total ? (count / total) * 100 : 0) + "%";
    if (this.finishButton) this.finishButton.disabled = !unlocked;
    if (this.finishLabel) {
      this.finishLabel.textContent = unlocked ? this.finishUnlockedLabel : this.finishLockedLabel;
    }
    if (this.finishHint) this.finishHint.hidden = unlocked;
  };

  FruitVote.prototype.updateTotalVotes = function () {
    if (!this.totalVotesElement || this.totalVotes === null) return;
    this.totalVotesElement.textContent = formatNumber(this.totalVotes);
  };

  FruitVote.prototype.mergeRankings = function (payload) {
    var self = this;
    if (!payload || !Array.isArray(payload.fruits)) return;

    payload.fruits.forEach(function (row) {
      var fruit = self.fruitById[row.fruit_id];
      if (!fruit) return;
      fruit.score = Number(row.score) || 0;
      fruit.likes = Number(row.likes) || 0;
      fruit.dislikes = Number(row.dislikes) || 0;
      self.renderFruit(fruit);
    });

    if (typeof payload.totalVotes === "number") {
      this.totalVotes = payload.totalVotes;
      this.updateTotalVotes();
    }

    this.sortAndRender(true);
  };

  FruitVote.prototype.loadRankings = function () {
    var self = this;
    if (!this.endpoint || this.destroyed) return;

    var controller = "AbortController" in window ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 8000);

    fetch(this.endpoint + "/rankings", {
      method: "GET",
      cache: "no-store",
      signal: controller ? controller.signal : undefined,
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Ranking request failed");
        return response.json();
      })
      .then(function (payload) {
        self.mergeRankings(payload);
        self.updated.textContent = "Live · just now";
      })
      .catch(function () {
        self.updated.textContent = "Reconnecting…";
      })
      .then(function () {
        window.clearTimeout(timeout);
      });
  };

  FruitVote.prototype.startPolling = function () {
    var self = this;
    if (this.pollTimer || !this.endpoint) return;
    this.pollTimer = window.setInterval(function () {
      if (!document.hidden) self.loadRankings();
    }, this.pollMilliseconds);
  };

  FruitVote.prototype.openDialog = function () {
    if (!this.dialog) return;
    this.updateTopFive(this.getSortedFruits().slice(0, 5));
    if (typeof this.dialog.showModal === "function" && !this.dialog.open) {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute("open", "");
    }
  };

  FruitVote.prototype.closeDialog = function () {
    if (!this.dialog) return;
    if (typeof this.dialog.close === "function" && this.dialog.open) {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute("open");
    }
  };

  FruitVote.prototype.share = function (button) {
    var heading = this.root.querySelector("h1");
    var shareData = {
      title: heading ? heading.textContent.trim() : "The Great Fruit Vote",
      text: "Help OhCrisp build the next Signature Mix. Which fruits deserve the top five?",
      url: window.location.href,
    };

    if (navigator.share) {
      navigator.share(shareData).catch(function () {});
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      var original = button.textContent;
      navigator.clipboard.writeText(window.location.href).then(function () {
        button.textContent = "Link Copied!";
        window.setTimeout(function () { button.textContent = original; }, 1800);
      }).catch(function () {});
    }
  };

  FruitVote.prototype.announce = function (message) {
    if (!this.status) return;
    this.status.textContent = "";
    var self = this;
    window.setTimeout(function () { self.status.textContent = message; }, 20);
  };

  FruitVote.prototype.destroy = function () {
    this.destroyed = true;
    window.clearInterval(this.pollTimer);
    this.pollTimer = 0;
    if (this.onVisibilityChange) {
      document.removeEventListener("visibilitychange", this.onVisibilityChange);
    }
  };

  function init(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches("[data-ohc-fruit-vote]")) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll("[data-ohc-fruit-vote]")));
    }

    roots.forEach(function (root) {
      if (root.dataset.ohcvReady) return;
      root.dataset.ohcvReady = "true";
      root.ohcFruitVote = new FruitVote(root);
    });
  }

  function boot() {
    init(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var root = event.target.querySelector && event.target.querySelector("[data-ohc-fruit-vote]");
    if (root && root.ohcFruitVote) root.ohcFruitVote.destroy();
  });
})();
